import { Controller } from "@hotwired/stimulus"

// Inicializa o CKEditor 4 (carregado globalmente via Sprockets) sobre o
// textarea-alvo. Mesma config usada em contrato_modelos e contratos.
// Destrói a instância no disconnect para não duplicar editor ao revisitar
// a página (Turbo Drive).
const CONFIG = {
  language: "pt-BR",
  height: 400,
  toolbar: [
    { name: "document", groups: ["mode", "document", "doctools"], items: ["Source", "-", "Save", "NewPage", "Preview", "Print", "-", "Templates"] },
    { name: "clipboard", groups: ["clipboard", "undo"], items: ["Cut", "Copy", "Paste", "PasteText", "PasteFromWord", "-", "Undo", "Redo"] },
    { name: "editing", groups: ["find", "selection", "spellchecker"], items: ["Find", "Replace", "-", "SelectAll", "-", "Scayt"] },
    "/",
    { name: "basicstyles", groups: ["basicstyles", "cleanup"], items: ["Bold", "Italic", "Underline", "Strike", "Subscript", "Superscript", "-", "CopyFormatting", "RemoveFormat"] },
    { name: "paragraph", groups: ["list", "indent", "blocks", "align", "bidi"], items: ["NumberedList", "BulletedList", "-", "Outdent", "Indent", "-", "Blockquote", "-", "JustifyLeft", "JustifyCenter", "JustifyRight", "JustifyBlock", "-", "BidiLtr", "BidiRtl"] },
    { name: "links", items: ["Link", "Unlink", "Anchor"] },
    { name: "insert", items: ["Image", "Table", "HorizontalRule", "Smiley", "SpecialChar", "PageBreak"] },
    "/",
    { name: "styles", items: ["Styles", "Format", "Font", "FontSize"] },
    { name: "colors", items: ["TextColor", "BGColor"] },
    { name: "tools", items: ["Maximize", "ShowBlocks"] }
  ]
}

export default class extends Controller {
  connect() {
    if (typeof CKEDITOR === "undefined") return
    // evita "editor already exists" ao revisitar a página
    const stale = CKEDITOR.instances[this.element.id]
    if (stale) stale.destroy(true)
    this.editor = CKEDITOR.replace(this.element, CONFIG)
  }

  disconnect() {
    if (this.editor) {
      this.editor.destroy(true)
      this.editor = null
    }
  }
}
